import React, { FC } from 'react';
import { Button, ButtonProps } from 'antd';
import { useTranslation } from 'react-i18next';

import { BravoLogoutIcon } from '../styledComponents';

const LogoutButton: FC<ButtonProps> = (props) => {
  const { t } = useTranslation();

  return (
    <Button icon={<BravoLogoutIcon />} {...props}>
      {t('settings.logout')}
    </Button>
  );
};

export default LogoutButton;
